import client from '@/config/directus.api';

const COLLECTION = 'bb_articles';

/**
 * Get articles
 *
 */
export function getArticles(filter = {}) {
  try {
    const response = client.getItems(COLLECTION, {
      fields: ['*', 'created_by.*', 'tags.*.*'],
      sort: '-created_on',
      status: 'published',
      filter
    });

    return response;
  } catch (error) {
    throw new Error(error);
  }
}

/**
 * Get article by id
 *
 * @param {int} id
 */
export function getArticleById(id) {
  try {
    const response = client.getItems(COLLECTION, {
      fields: ['*', 'created_by.*', 'tags.*'],
      status: 'published',
      filter: {
        id
      }
    });

    return response;
  } catch (error) {
    throw new Error(error);
  }
}

/**
 * Publish article by uuid
 *
 * @param {string} uuid
 */
export function publishArticleByUuid(uuid) {
  try {
    return client.get(`custom/bb_articles/publish?uuid=${uuid}`);
  } catch (error) {
    throw new Error(error);
  }
}
